import './App.css';
import { HintBox, ContentNavigation, Theme, ThemeProvider, Container, Flex } from "@dtpk-cc/components";

import DeviceDeviceTvDefault from "@dtpk-cc/components/dist/icons/Device/DeviceTv/Default";
import ContentContentCalendarDefault from "@dtpk-cc/components/dist/icons/Content/Calendar/Default";
import ContentContentTariffsDefault from "@dtpk-cc/components/dist/icons/Content/Tariffs/Default";
import AlertAlertHelpDefault from "@dtpk-cc/components/dist/icons/Alert/Help/Default";

import "@dtpk-cc/components/dist/components/HintBox/HintBox.css";
import "@dtpk-cc/components/dist/global.css";
import "@dtpk-cc/components/dist/index.css";
import "@dtpk-cc/components/dist/components/ContentNavigation/ContentNavigation.css";
import "@dtpk-cc/components/dist/components/Button/Button.css";
import "@dtpk-cc/components/dist/components/Icon/Icon.css";
import "@dtpk-cc/components/dist/components/Container/Container.css";
import "@dtpk-cc/components/dist/components/Flex/Flex.css";



export default function App () {
  return (
    <Container>
      <ThemeProvider value={Theme.dark}>
        <ContentNavigation>
          <ContentNavigation.Item
            tag="a"
            href="//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/"
            icon={ContentContentCalendarDefault}
            onClick={clickEvent0}
          >
            Termine
          </ContentNavigation.Item>
          <ContentNavigation.Item
            tag="a"
            href="//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/archiv"
            icon={DeviceDeviceTvDefault}
            iconWrapperProps={{ style: { marginTop: 1 } }}
            onClick={clickEvent1}
          >
            Archiv
          </ContentNavigation.Item>
          <ContentNavigation.Item
            tag="a"
            href="https://www.telekom.de/netz/glasfaser"
            icon={ContentContentTariffsDefault}
            iconWrapperProps={{ style: { marginTop: 4 } }}
            onClick={clickEvent2}
          >
            Tarife
          </ContentNavigation.Item>
          <ContentNavigation.Item
            tag="a"
            href="//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/faq"
            icon={AlertAlertHelpDefault}
            iconWrapperProps={{ style: { marginTop: 4 } }}
            onClick={clickEvent3}
          >
            FAQ
          </ContentNavigation.Item>
        </ContentNavigation>
      </ThemeProvider>
      <ThemeProvider value={Theme.light}>
        <Container>
          <Flex justifyContent="center">
            <HintBox variants={HintBox.Variant.alert}>
              <HintBox.Heading>Hinweis:</HintBox.Heading>
              <HintBox.Text>
                Die Seite der virtuellen Infoveranstaltungen wird zum 01.07.2024 abgeschaltet.
              </HintBox.Text>
              <HintBox.Text>
                Auch die Archivseiten stehen ab dann nicht mehr zur Verfügung.
              </HintBox.Text>
            </HintBox>
          </Flex>
        </Container>
      </ThemeProvider>
    </Container>
  );
}

function clickEvent0 (e) {
  e.preventDefault();
  //window.utag.link({ wt_link_id: 'content.button-termine' });
  window.location.href = "//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/";
}
function clickEvent1 (e) {
  e.preventDefault();
  // window.utag.link({ wt_link_id: 'content.button-archiv' });
  window.location.href = "//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/archiv";
}
function clickEvent2 (e) {
  e.preventDefault();
  //window.utag.link({ wt_link_id: 'content.button-tarife' });
  window.top.location.href = "https://www.telekom.de/netz/glasfaser";
}
function clickEvent3 (e) {
  e.preventDefault();
  //window.utag.link({ wt_link_id: 'content.button-faq' });
  window.location.href = "//ebs09.telekom.de/magenta-infoveranstaltungen/mgiv/faq";
}